import React from "react";
import style from "./TradeIn.module.css";
import { Button, Table } from "react-bootstrap";
import { connect } from "react-redux";
import {
  addQuoteItemTradeIn,
  deleteQuoteItemTradeIn,
  setQuoteItemTradeInField
} from "../redux/actions";

function TradeIn({
  addQuoteItemTradeIn,
  deleteQuoteItemTradeIn,
  setQuoteItemTradeInField,
  tradeInGroup,
  item,
  tradeInGroupIndex,
  opportunityAddresses
}) {
  return (
    <Table variant="sm" className={style.root}>
      <tbody>
        {tradeInGroup.map((tradeInItem, tradeInIndex) => (
          <tr key={tradeInIndex}>
            <td className={style.brand}>
              <input
                className="form-control"
                type="text"
                value={tradeInItem.brand || ""}
                onChange={e =>
                  setQuoteItemTradeInField(
                    item,
                    tradeInGroupIndex,
                    tradeInIndex,
                    "brand",
                    e.target.value
                  )
                }
              />
            </td>
            <td className={style.model}>
              <input
                className="form-control"
                type="text"
                value={tradeInItem.model || ""}
                onChange={e =>
                  setQuoteItemTradeInField(
                    item,
                    tradeInGroupIndex,
                    tradeInIndex,
                    "model",
                    e.target.value
                  )
                }
              />
            </td>
            <td className={style.serialNo}>
              <input
                className="form-control"
                type="text"
                value={tradeInItem.serialNumber || ""}
                onChange={e =>
                  setQuoteItemTradeInField(
                    item,
                    tradeInGroupIndex,
                    tradeInIndex,
                    "serialNumber",
                    e.target.value,
                    opportunityAddresses
                  )
                }
              />
            </td>
            <td className={style.action}>
              {tradeInIndex ? (
                <Button
                  variant="secondary"
                  block
                  onClick={() =>
                    deleteQuoteItemTradeIn(
                      item,
                      tradeInGroupIndex,
                      tradeInIndex
                    )
                  }
                >
                  -
                </Button>
              ) : (
                <Button
                  block
                  onClick={() => addQuoteItemTradeIn(item, tradeInGroupIndex)}
                >
                  +
                </Button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default connect(state => {const { Addresses } = state.opportunity; return {opportunityAddresses: Addresses}}, {
  addQuoteItemTradeIn,
  deleteQuoteItemTradeIn,
  setQuoteItemTradeInField
})(TradeIn);
